import {defineStore} from 'pinia'
import {Loading} from "@/store/Loading";

export const Profile = defineStore('Profile', {
    state: () => ({
        token: null,
        identity: null,
        assistantId: null,
        firstname: null,
        first_name: null,
        lastname: null,
        last_name: null,
        gender: 'Erkek',
        birthDate: null,
        birth_date: null,
        birthTime: null,
        birth_time: null,
        birthCity: 'İstanbul',
        birth_place: 'İstanbul',
        relationship: 'Bekar',
        children: null,
        employment: 'Çalışıyorum',
        job: null,
        is_onboarding_completed: false,
        steps: {
            "step1": false,
            "step2": false,
            "step3": false,
            "step4": false,
            "step5": false,
            "step6": false,
        },
        msisdn: null
    }),

    actions: {
        async saveToken(token) {
            this.token = token;

            await this.saveLocalStorage();
            // localStorage.setItem('_profile', JSON.stringify(this.$state));

        },

        async checkToken() {
            await this.get();

            return !!this.token;
        },

        async saveLocalStorage() {
            localStorage.setItem('_profile', JSON.stringify(this.$state));
        },

        async saveStep(stepName = null) {
            // First, ensure we have the latest data from localStorage
            const profile = await this.get();

            // Update the step status if a valid step name is provided
            if (stepName && this?.steps?.hasOwnProperty(stepName)) {
                this.steps[stepName] = true;
            }

            // Save all profile data to localStorage
            await this.saveLocalStorage();
        },

        async get() {
            const profile = JSON.parse(localStorage.getItem('_profile'));
            if (profile) {
                for (const state in this.$state) {
                    this[state] = profile[state];
                }
            }
            return this;
        },

        async delete() {
            await localStorage.removeItem('_profile');
            await localStorage.removeItem('__profile');
            this.$reset();
        },

        async logout() {
            await this.delete();
        },

        async update(userUpdateObject) {
            const profile = this.getStoredProfileData();

            for (const state in this.$state) {
                if (typeof userUpdateObject[state] !== 'undefined') {
                    this[state] = userUpdateObject[state];
                }
            }

            // update local storage
            await this.saveLocalStorage();

            // update db
            return await this.$api.put('/user-update', {
                token: profile.token,
                identity: profile.identity,
                user: userUpdateObject
            });
        },

        getLastUncompletedStep() {
            this.get();
            for (const step in this.steps) {
                if (this.steps[step] === false) {
                    return step;
                }
            }

            return true;
        },

        async isProfileCreated() {
            const lastUncompletedStep = await this.getLastUncompletedStep();
            return lastUncompletedStep === true;
        },

        getStoredProfileData() {
            console.log('getStoredProfileData');

            const profile = JSON.parse(localStorage.getItem('_profile'));
            if (profile) {
                for (const state in this.$state) {
                    this[state] = profile[state];
                }
            }
            return profile;
        },

        async getLoggedProfile() {
            const profile = this.getStoredProfileData();

            if (!profile) {
                return false;
            }

            Loading().show();
            const profileResponse = await this.$api.post('/profile', {
                token: profile.token
            });
            Loading().hide();

            return profileResponse.data;
        },

        /**
         * Check profile is logged and available, redirects to after logged page
         *
         * @param to
         * @param from
         * @param next
         * @param {boolean} checkForLogged
         * @returns {Promise<void>}
         */
        async beforeRouteEnterCheckLogin(to, from, next, checkForLogged = false) {
            const profile = await Profile().getLoggedProfile();

            if (checkForLogged === false) {
                if (profile?.status) {
                    next('/predictions');
                    return;
                }
            } else {
                if (!profile?.status) {
                    localStorage.removeItem('_profile');
                    localStorage.removeItem('__profile');

                    next('/');
                    return;
                }
            }

            if (Profile().is_onboarding_completed !== true) {
                // next('/personalization/1');
                next('/');
                return;
            }
            next();
        }
    }
});
